import {SolutionResponse} from '../solution/solution-support.types';
import {IGetAlternativesRequest} from './load-alternatives';
import {Activity} from '@mobi-components/global-solution';
import {APIService} from '@/services/api.service';

export async function submitAlternativeActivity(
  requestDetails: IGetAlternativesRequest,
  activity: Activity,
): Promise<SolutionResponse> {
  return APIService.post<SolutionResponse>(`alternative-activity`, activity, {
    params: {
      session_id: requestDetails.sessionId,
      problem_id: requestDetails.problemId,
      solution_id: requestDetails.solutionId,
      activity_id: requestDetails.activityId,
      replan: false,
    },
  });
}
